// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1aLUj","title":"AfterFrontImage_title__12uVM"};